import type { Dispatch, AnyAction } from 'redux';

import * as BulkEditJobMaterialAPI from 'ab-api/web/jobMaterial/editBulk';
import * as FindImportedIdsAPI from 'ab-api/web/jobMaterial/findCurrentlyImportedIds';
import * as FindGroupsJobMaterialAPI from 'ab-api/web/jobMaterial/findGroups';
import * as FindTableJobMaterialAPI from 'ab-api/web/jobMaterial/findTable';
import * as RemoveBulkJobMaterialAPI from 'ab-api/web/jobMaterial/removeBulk';
import * as SyncJobMaterialAPI from 'ab-api/web/jobMaterial/sync';
import * as SyncDiffJobMaterialAPI from 'ab-api/web/jobMaterial/syncDiff';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

export function syncJobMaterials(jobId: number, data: SyncJobMaterialAPI.W_JobMaterial_Sync_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put<void>(SyncJobMaterialAPI.URL(jobId), data);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function calculateJobMaterialsSyncDiff(jobId: number, data: SyncDiffJobMaterialAPI.W_JobMaterial_SyncDiff_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put<SyncDiffJobMaterialAPI.W_JobMaterial_SyncDiff_VM>(SyncDiffJobMaterialAPI.URL(jobId), data);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

interface FindJobMaterials {
	group: Nullable<string>;
	search: string;
	page: number;
}
export function findTable(jobId: number, event: FindJobMaterials) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const { group, search, page } = event;
			const url = `${FindTableJobMaterialAPI.URL(jobId, group ?? '', search, page)}`;
			return await http.get<FindTableJobMaterialAPI.W_JobMaterial_FindTable_VM>(url);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findGroups(jobId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const url = FindGroupsJobMaterialAPI.URL(jobId);
			return await http.get<FindGroupsJobMaterialAPI.W_JobMaterial_FindGroups_VM>(url);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function editJobMaterialBulk(jobId: number, data: BulkEditJobMaterialAPI.W_JobMaterial_EditBulk_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put<void>(BulkEditJobMaterialAPI.URL(jobId), data);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function removeBulk(jobId: number, data: RemoveBulkJobMaterialAPI.W_JobMaterial_RemoveBulk_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.post<void>(RemoveBulkJobMaterialAPI.URL(jobId), data);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findImportedIdsForJob(jobId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindImportedIdsAPI.W_JobMaterial_FindCurrentlyImportedIds_VM>(FindImportedIdsAPI.URL(jobId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
